<template>
  <div class="modal-container" @click.self="handleClickOutside" role="dialog" aria-modal="true">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        closeOnClickOutside: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        cancel(){
            this.$emit('cancel');
        },
        handleClickOutside() {
            if (this.closeOnClickOutside) {
                this.cancel();
            }
        },
    }
});
</script>

<style>
.modal-container {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: var(--blur);
}
</style>
